export const linkStyle = {
  textDecoration: "none",
};

